import React, { useState } from 'react'
import s from './post-payment-fail.module.scss'
import { IconCircleXFilled } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { Button } from '@shared/ui/button/button';
import { useCancelOrderModal } from '@features/student/cancel-order/model/use-cancel-order-modal';
import { useNavigate } from 'react-router-dom';
import { classes } from '@shared/api/services';
import { toast } from 'react-toastify';
import { getCDNPath } from '@utils/lib/getCDNpath';


export const PostPaymentFail = ({teacher_slug, orderId}) => {
	const { open: openCancelOrder } = useCancelOrderModal()
	const navigate = useNavigate()
	const [isRetrying, setIsRetrying] = useState(false)

	const handleRetry = async () => {
		if (!orderId) return
		setIsRetrying(true)
		try {
			const payment = await classes.payForAppointment(orderId)
			if (payment?.data?.payment_url) {
				window.open(payment.data.payment_url, "_self")
			} else {
				toast.error('Не удалось получить ссылку на оплату')
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || 'Ошибка при повторе оплаты')
		} finally {
			setIsRetrying(false)
		}
	}

	return (
		<motion.div
			className={s.wrapper}
			initial={{ opacity: 0, y: 16 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
		>
			<div className={s.card}>
				<div className={s.header}>
					<div className={s.headerContent}>
						<motion.span
							className={s.badge}
							initial={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{ type: 'spring', stiffness: 260, damping: 18, delay: 0.1 }}
						>
							<IconCircleXFilled size={36} className={s.badgeIcon}/>
						</motion.span>
						<h2 className={s.title}>Не удалось оплатить</h2>
						<p className={s.subtitle}>
							Средства не списались — проверьте данные карты и попробуйте снова.
							Если ошибка повторяется, попробуйте другую карту или отмените заказ.
						</p>
					</div>
					<img
						className={s.mascot}
						src={getCDNPath('images/mascot/sad.webp')}
						alt=""
						onError={(e) => { e.target.style.display = 'none'; }}
					/>
				</div>
				<div className={s.buttons}>
					<Button theme='secondary' label='Отменить заказ' onClick={() => openCancelOrder({orderId, onClose: () => navigate('/')})} className={s.btn}/>
					<Button label='Повторить' onClick={handleRetry} fetching={isRetrying} className={s.btn}/>
				</div>
				{orderId ? <span className={s.orderNumber}>Заказ №{orderId}</span> : null}
			</div>
		</motion.div>
	)
}
